/* ============================================================
   Ürün kartı — video oynatıcı
   Videosu olan kartlardaki ▶ butonuna basınca videoyu tam ekran bir
   pencerede oynatır. Kapatınca (X, arka plan, Esc ya da telefonun geri
   tuşu) sayfa değişmediği için müşteri listede kaldığı yerde kalır.
   Buton + video şablonu: snippets/product-card.liquid
   Stil ve bu dosyanın yüklenmesi: snippets/card-video.liquid (layout'ta)
   Ayrıca: ilk medyası video olan kartlarda videoyu kart görseli olarak
   sessiz ve döngüde oynatır (dosyanın sonundaki bölüm).
============================================================ */
(function () {
  'use strict';
  if (window.__cardVideo) return;
  window.__cardVideo = true;

  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var modal, stage, titleEl, linkEl, closeBtn;
  var isOpen = false;
  var lastTrigger = null;
  var pendingUrl = null;
  var resumeInline = null;

  function build() {
    modal = document.createElement('div');
    modal.className = 'card-video';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<button type="button" class="card-video__backdrop" data-card-video-close aria-label="Close video"></button>' +
      '<button type="button" class="card-video__close" data-card-video-close aria-label="Close video">' + ICON_CLOSE + '</button>' +
      '<div class="card-video__panel">' +
        '<div class="card-video__stage"></div>' +
        '<div class="card-video__footer"><span class="card-video__title"></span><a class="card-video__link" href="#"></a></div>' +
      '</div>';
    document.body.appendChild(modal);
    stage = modal.querySelector('.card-video__stage');
    titleEl = modal.querySelector('.card-video__title');
    linkEl = modal.querySelector('.card-video__link');
    closeBtn = modal.querySelector('.card-video__close');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-card-video-close]')) requestClose();
    });
    linkEl.addEventListener('click', function (e) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      // Önce pencerenin geçmiş kaydını geri al, sonra ürüne git: ürün sayfasından
      // geri basınca liste tek adımda, kaldığı yerde açılır
      if (history.state && history.state.cardVideo) {
        e.preventDefault();
        pendingUrl = linkEl.href;
        history.back();
      }
    });
  }

  function open(btn) {
    if (isOpen) return; // çift tıklamada ikinci geçmiş kaydı açılmasın
    var card = btn.closest('.card');
    var tpl = card && card.querySelector('template[data-card-video-template]');
    if (!tpl) return;
    if (!modal) build();
    lastTrigger = btn;
    // Kartın kendi içindeki video pencere açıkken boşuna oynamasın
    var inline = card.querySelector('video[data-card-inline-video]');
    if (inline && !inline.paused) { inline.pause(); resumeInline = inline; }
    stage.innerHTML = '';
    stage.appendChild(tpl.content.cloneNode(true));
    titleEl.textContent = btn.getAttribute('data-title') || '';
    linkEl.href = btn.getAttribute('data-url') || '#';
    linkEl.textContent = btn.getAttribute('data-link-label') || '';
    modal.hidden = false;
    isOpen = true;
    document.body.style.overflow = 'hidden';
    history.pushState({ cardVideo: true }, '');
    closeBtn.focus({ preventScroll: true });
    var video = stage.querySelector('video');
    if (!video) return; // YouTube/Vimeo iframe kendi oynatır
    video.controls = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.muted = false;
    // Tıklamayla açıldığı için sesli başlar; tarayıcı izin vermezse sessiz başlar
    var playing = video.play();
    if (playing && playing.catch) playing.catch(function () {
      video.muted = true;
      var retry = video.play();
      if (retry && retry.catch) retry.catch(function () {});
    });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    stage.innerHTML = ''; // video DOM'dan çıkınca durur, indirmesi de kesilir
    modal.hidden = true;
    document.body.style.overflow = '';
    if (resumeInline) {
      var resumed = resumeInline.play();
      if (resumed && resumed.catch) resumed.catch(function () {});
      resumeInline = null;
    }
    if (lastTrigger) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // Kapatma her zaman geçmişten geçer; böylece X ile kapatınca da geri tuşunda fazladan adım kalmaz
  function requestClose() {
    if (!isOpen) return;
    if (history.state && history.state.cardVideo) history.back();
    else close();
  }

  window.addEventListener('popstate', function () {
    close();
    if (pendingUrl) {
      var url = pendingUrl;
      pendingUrl = null;
      window.location.href = url;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) requestClose();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-video]');
    if (!btn) return;
    e.preventDefault();
    open(btn);
  });

  /* ---- Kart görseli olarak video (admin'de ilk medya videoysa) ----
     Sadece kart ekrandayken oynar; preload="none" olduğu için görünmeyen
     kartın videosu inmez. Veri tasarrufu, yavaş bağlantı veya hareket
     azaltma tercihinde kapak karesi kalır. */
  var conn = navigator.connection || {};
  var skipInline = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    conn.saveData === true || /2g$/.test(conn.effectiveType || '');
  if (skipInline || !('IntersectionObserver' in window)) return;

  var inlineVideos = [];
  var productJson = {};
  // Liquid karta sadece 1080p mp4 verebiliyor. Kartın genişliğine yetecek en küçük
  // sürümü ürünün .js verisinden seç (ürün başına bir istek, önbellekli).
  function pickSource(v) {
    var url = v.getAttribute('data-product-json');
    if (!url) return Promise.resolve();
    productJson[url] = productJson[url] || fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productJson[url].then(function (p) {
      var id = Number(v.getAttribute('data-media-id'));
      var media = p && (p.media || []).filter(function (m) { return m.id === id; })[0];
      var mp4 = media ? (media.sources || []).filter(function (s) { return s.format === 'mp4' && s.width && s.url; }) : [];
      if (!mp4.length) return;
      mp4.sort(function (a, b) { return a.width - b.width; });
      var need = v.clientWidth * Math.min(window.devicePixelRatio || 1, 2) * 0.8;
      var best = mp4.filter(function (s) { return s.width >= need; })[0] || mp4[mp4.length - 1];
      v.src = best.url;
    });
  }
  function playInline(v) {
    if (isOpen) return;
    v.muted = true;
    if (!v._srcReady) {
      if (v._srcPending) return;
      v._srcPending = true;
      pickSource(v).catch(function () {}).then(function () {
        v._srcReady = true;
        v._srcPending = false;
        if (v._cardVisible) playInline(v);
      });
      return;
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target;
      v._cardVisible = en.isIntersecting;
      if (en.isIntersecting) playInline(v);
      else if (!v.paused) v.pause();
    });
  }, { threshold: 0.35 });
  function watch(scope) {
    var list = scope.matches && scope.matches('video[data-card-inline-video]') ? [scope]
      : scope.querySelectorAll ? scope.querySelectorAll('video[data-card-inline-video]') : [];
    Array.prototype.forEach.call(list, function (v) {
      if (v._cardInline) return;
      v._cardInline = true;
      v.muted = true;
      v.playsInline = true;
      inlineVideos.push(v);
      io.observe(v);
    });
  }
  watch(document);
  // Sonsuz kaydırma ve öneri blokları kartları sonradan ekler
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      Array.prototype.forEach.call(r.addedNodes, function (n) { if (n.nodeType === 1) watch(n); });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  // Arka plan sekmesinde açılan sayfada tarayıcı oynatmayı bekletir; sekme görünür olunca başlat
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    inlineVideos.forEach(function (v) { if (v._cardVisible && v.paused && v.isConnected) playInline(v); });
  });
})();
